// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@sc/App/SharedStyles/MyAccountPages/Details/OrderTotalDisplaySharedStyles";
import { orderSummaryStyles } from "@sc/Overrides/Widgets/OnePageCheckoutConfirmation/OnePageCheckoutConfirmationOrderSummary";
import { css } from "styled-components";

orderSummaryStyles.container = {
    css: css`
        ${orderTotalDisplaySharedStyles.wrapper?.css}
    `,
};

orderSummaryStyles.actionsWrapper = {
    css: css`
        margin-top: 16px;
    `,
};

orderSummaryStyles.continueButton = {
    sizeVariant: "large",
    variant: "primary",
    css: css`
        width: 100%;
    `,
};
